import { TREATMENTS } from '../constants/progressCategories';
import { MY_TREATMENTS } from '../constants';

const myTreatmentsExtensionsTypes = {
  name: 'extensions',
  category: MY_TREATMENTS,
  progressCategory: TREATMENTS,
  route: `/consultation/${MY_TREATMENTS}/extensions`,
  title: 'Do you wear any of these styles?',
  subtitle: 'Select all that apply. Include any style you plan to wear in the near future.',
  tip: {
    title: 'Not sure? Here’s what we mean:',
    content: `**Natural or synthetic extensions** are hair pieces that can be clipped in, taped in, sewn in, or woven in to make hair appear longer or fuller.

&nbsp;

**Wigs** can be full-head or partially-open hair units.

&nbsp;

**Protective styles** can be done with your own hair or with synthetic braiding hair and are installed for a couple weeks to avoid manipulation and protect hair.

&nbsp;

**Locs** is a hairstyle in which strands of hair are tangled together forming individual rope-like locks of hair.`,
  },
  multi: true,
  options: [
    { value: 'natural_extensions', label: 'Natural extensions' },
    { value: 'synthetic_extensions', label: 'Synthetic extensions' },
    { value: 'wigs', label: 'Wigs' },
    {
      value: 'protective_braids_twists_faux_locs',
      label: 'Protective braids, twists, or faux-locs',
    },
    { value: 'dreadlocks', label: 'Locs / Dreadlocks' },
    { value: 'none', label: 'None of the above', unique: true },
  ],
  // Dynamic logic
  shouldBeIncluded: () => true,
  getInitialValue: answers => answers.diag_extensions,
  getAnswers: ({ selected }) => ({ diag_extensions: selected }),
};

export default myTreatmentsExtensionsTypes;
